import { API_HOST, getHttpGetOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/system-user`;

const getRetrieveShortcutsEndpoint = (personExternalReference) =>
  `${getEndpoint()}/retrieve/homepage/shortcuts/${personExternalReference}`;
export const getRetrieveShortcutsRequest = (personExternalReference) => [
  getRetrieveShortcutsEndpoint(personExternalReference),
  getHttpGetOptions(),
];

const getRetrieveAdminPingsEndpoint = (personExternalReference) =>
  `${getEndpoint()}/retrieve/admin/pings/${personExternalReference}`;
export const getRetrieveAdminPingsRequest = (personExternalReference) => [
  getRetrieveAdminPingsEndpoint(personExternalReference),
  getHttpGetOptions(),
];
